import FormEditor from '~/components/modals/FormEditor.vue'
import axios from 'axios'

export default {
  methods: {
    async editForm (id, name) {
      try {
        let response = await axios.get(this.baseDomain + this.shopId + '/forms/' + id + '.json?version=' + this.version + '&apikey=' + this.apiKey)
        this.editFormDialog(response.data)
      } catch (error) {
        console.error(error)
      }
    },
    editFormDialog (form) {
      this.showModal('formeditor', FormEditor, {
        props: {
          sourceForm: form
        },
        events: {
          saveForm: this.saveForm,
          deleteForm: this.deleteForm
        },
        handlers: {},
        width: 800
      })
    },
    addFormDialog () {
      this.showModal('formeditor', FormEditor, {
        events: {
          saveForm: this.saveForm
        },
        handlers: {},
        width: 800
      })
    },
    async saveForm (data) {
      data.version = this.version
      if (data.id) {
        try {
          await axios.put(this.baseDomain + this.shopId + '/forms/' + data.id + '.json?version=' + this.version + '&apikey=' + this.apiKey, data)
        } catch (error) {
          console.error(error)
        }
      } else {
        try {
          await axios.post(this.baseDomain + this.shopId + '/forms.json?version=' + this.version + '&apikey=' + this.apiKey, data)
        } catch (error) {
          console.error(error)
        }
      }
      console.log(data)
    },
    async deleteForm (data) {
      if (!data || !data.id) {
        return
      }
      try {
        await axios.delete(this.baseDomain + this.shopId + '/forms/' + data.id + '.json?apikey=' + this.apiKey)
      } catch (error) {
        this.showError(error)
      }
    }
  },
  components: {
    FormEditor
  }
}